/* RESPONSIBLE TEAM: team-standalone */

export default {
  icon: 'zendesk',
  navItemTranslationKey: 'components.primary-nav.fin-for-zendesk',
} as const;
